import {
  useEffect,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import clsx from "clsx";
import { BiEdit } from "react-icons/bi";
import { SimpleActionDialog } from "../../../components";
import { useRedirect } from "react-admin";
import { routePaths } from "../../../baseLayout/SidebarMenu";
// import EmptyFileWarning from "../../EventSessions/CSVUploadFlow/EmptyFileWarning";
import FdTypography from "../../../components/UIComponents/Typography/FdTypography";
import FdButton from "../../../components/UIComponents/Button/FdButton";
import {eventSourceSelector as classes} from "../styles";

export type IProps = {
  providerSelect: Function;
  fileUpload: Function;
};

export enum flowType {
  CSV_EVENT = "csv_event",
  CUSTOM_EVENT = "custom_event",
}

const EventSourceSelector = (
  { providerSelect, fileUpload }: IProps,
  ref: any
) => {
  const redirect = useRedirect();
  const [, setProviders] = useState<any[]>([]);
  const [actionDialog, setActionDialog] = useState({
    open: false,
    content: <></>,
  });
  const csvUploaderRef = useRef<any>();

  useImperativeHandle(
    ref,
    () => ({
      openCSVWarning() {
        showCSVWarning();
      },
    }),
    []
  );

  // initialize providers list
  useEffect(() => {
    loadProviders();
  }, []);

  const loadProviders = () => {
    const providers = [
      {
        id: 1,
      },
      {
        id: 2,
      },
      {
        id: 3,
      },
      {
        id: 4,
      },
      {
        id: 5,
      },
    ];
    setProviders(providers);
  };

  // const handleProviderSelect = () => {
  //   providerSelect("custom");
  // };

  // const getProvidersList = (providers: any) => {
  //   return providers.map((provider: any) => {
  //     return (
  //       <Grid key={provider.id} item xs={3}>
  //         <div
  //           className={classes.providerButton}
  //           onClick={() => {
  //             providerSelect({ type: flowType.CSV_EVENT });
  //           }}
  //         >
  //           <CardMedia
  //             component={"img"}
  //             className={clsx(classes.media)}
  //             src="https://place-hold.it/100x100/fff/red.png&text=eventbrite"
  //           />
  //         </div>
  //       </Grid>
  //     );
  //   });
  // };

  const getCustomProviderButton = () => {
    return (
      <Grid
        key={"custom_provider"}
        item
        // xs={3}
      >
        <Box
          sx={classes.customButton}
          onClick={() => {
            providerSelect({ type: flowType.CUSTOM_EVENT });
          }}
        >
          <Box sx={classes.customButtonIcon} mb={0}>
            <BiEdit />
          </Box>
          <FdTypography label={<>Custom <br /> Provider</>} sx={classes.customButtonLabel} />
        </Box>
      </Grid>
    );
  };

  // const handleFileUpload = (data: any, fileInfo: any, file: File) => {
  //   if (data.length === 0) {
  //     showEmptyFileWarning();
  //   } else {
  //     fileUpload(data, fileInfo, file);
  //   }
  // };

  // the popup where we show a warning in case en empty csv was uploaded
  // const showEmptyFileWarning = () => {
  //   setActionDialog({
  //     open: true,
  //     content: (
  //       <EmptyFileWarning
  //         onConfirm={() => {
  //           setActionDialog({
  //             ...actionDialog,
  //             open: false,
  //           });
  //           showCSVWarning();
  //         }}
  //       />
  //     ),
  //   });
  // };

  const showCSVWarning = () => {
    csvUploaderRef.current.showWarning();
  };

  // close the dialog
  const closeDialog = () => {
    setActionDialog({
      open: false,
      content: <></>,
    });
  };

  // const providersList = getProvidersList(providers);

  const customProviderButton = getCustomProviderButton();

  return <>
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      maxWidth="30%"
    >
      <FdTypography
        label="First, lets select your E-reg provider!"
        variant="h2"
        component="h2"
        sx={{ marginBottom: "20px" }}
      />
      <FdTypography label="
        Please select your E-reg platform first, so we know what kind of database
        we are going to hook up with fielddrive." />
      <Grid
        spacing={3}
        container
        sx={classes.providersList}
        justifyContent="center"
      >
        {/* {providersList} */}
        
        {/* HIDDEN THIS UNTIL THE FLOW IS DECIDED */}
        {/* <CSVUploader
          ref={csvUploaderRef}
          onFileUpload={handleFileUpload}
          type={dataType.ATTENDEES}
        /> */}
        {/* HIDDEN THIS UNTIL THE FLOW IS DECIDED */}

        {customProviderButton}
      </Grid>
    </Box>
    <FdButton
      sx={classes.issueButton}
      onClick={() => {
        redirect(`/${routePaths.ACTIVE_EVENTS}`);
      }}
      variant="text"
      ButtonName="Go to events"
   />

    <SimpleActionDialog
      title=""
      open={actionDialog.open}
      content={actionDialog.content}
      onClose={() => {
        closeDialog();
      }}
    />
  </>;
};

export default forwardRef(EventSourceSelector);
